import { ArrowRight } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { signIn } from "@/lib/auth-client";

function MicrosoftMark() {
  return (
    <svg
      viewBox="0 0 23 23"
      xmlns="http://www.w3.org/2000/svg"
      className="h-[22px] w-[22px]"
      role="img"
      aria-label="Microsoft"
    >
      <title>Microsoft</title>
      <rect x="1" y="1" width="10" height="10" fill="#F25022" />
      <rect x="12" y="1" width="10" height="10" fill="#7FBA00" />
      <rect x="1" y="12" width="10" height="10" fill="#00A4EF" />
      <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
    </svg>
  );
}

function SsoButton({
  icon,
  label,
  onClick,
  disabled,
}: {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="group grid w-full grid-cols-[22px_1fr_16px] items-center gap-3.5 rounded-md border border-input bg-card px-[18px] py-4 text-left text-sm font-semibold text-foreground transition-[border,box-shadow,transform] duration-150 hover:-translate-y-px hover:border-ring hover:shadow-[0_6px_18px_color-mix(in_oklab,var(--ring)_12%,transparent)] disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:translate-y-0 disabled:hover:border-input disabled:hover:shadow-none"
    >
      {icon}
      <span>{label}</span>
      <ArrowRight className="h-4 w-4 text-muted-foreground transition-[transform,color] duration-150 group-hover:translate-x-[3px] group-hover:text-[var(--ring)]" />
    </button>
  );
}

export function SsoButtons() {
  const [microsoftPending, setMicrosoftPending] = useState(false);

  async function continueWithMicrosoft() {
    setMicrosoftPending(true);
    // On success the browser is redirected to Microsoft then back to
    // `callbackURL`, so this only returns here on a failure to *start* the flow.
    const { error } = await signIn.social({
      provider: "microsoft",
      callbackURL: "/dashboard",
      errorCallbackURL: "/login",
    });
    if (error) {
      setMicrosoftPending(false);
      toast.error(
        error.message ?? "Couldn't start Microsoft sign-in. Use your @nymbl.app account.",
      );
    }
  }

  return (
    <div className="flex flex-col gap-3">
      <SsoButton
        icon={<MicrosoftMark />}
        label={microsoftPending ? "Redirecting to Microsoft…" : "Continue with Microsoft Azure"}
        onClick={continueWithMicrosoft}
        disabled={microsoftPending}
      />
    </div>
  );
}
